import React, { useEffect, useRef, useMemo } from 'react';
import styled from "styled-components";
import debounce from 'lodash.debounce';

const InputContainer = styled.div`
    width: 100%;
    position: relative;
`;

const CustomInput = styled.input`
    width: ${props => props.width || '100%'};
    padding-top: ${props => props.paddingTop || '10px'};
    padding-bottom: ${props => props.paddingBottom || '10px'};
    text-align: left;
    border: ${props => props.border || 'none'};
    border-radius: ${props => props.borderRadius || '16px'};
    padding-left: 54px;
`;

const CustomIcon = styled.i``;

const IconContainer = styled.div`
    position: absolute;
    top: 50%;
    left: 12px;
    z-index: 1;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    background-color: white;
    place-content: center;
`;

export default function CustomSearch({
                                         type = 'text',
                                         className,
                                         labelClassName,
                                         label,
                                         withoutDaley = false,
                                         placeholder,
                                         defaultValue = null,
                                         value,
                                         min,
                                         max,
                                         rows,
                                         onChange,
                                         disabled,
                                         readOnly,
                                         invalid,
                                         errorMessage,
                                         onKeyPress,
                                         checked,
                                         clear,
                                         setClear,
                                         width,
                                         inputWidth,
                                         borderRadius,
                                         border,
                                         paddingTop,
                                         paddingBottom,
                                         debTime = 1000,
                                     }) {
    const inputRef = useRef(null);

    // Debounce only once
    const debouncedOnChange = useMemo(() =>
        debounce((value) => {
            onChange({ target: { value } });
        }, debTime), [onChange]);

    useEffect(() => {
        if (clear) {
            if (inputRef.current) {
                inputRef.current.value = '';
            }
            setClear();
        }
    }, [clear, setClear]);

    useEffect(() => {
        return () => {
            debouncedOnChange.cancel(); // Clean up on unmount
        };
    }, [debouncedOnChange]);

    const handleSearch = (event) => {
        const value = event.target.value;

        if (withoutDaley) {
            onChange({ target: { value } });
        } else {
            debouncedOnChange(value);
        }
    };

    return (
        <div className='d-flex' style={{ width: width }}>
            {label && <label className={`form-control-label ${labelClassName}`}>{label}</label>}
            <InputContainer>
                <IconContainer>
                    <CustomIcon className='fa fa-search' />
                </IconContainer>
                <CustomInput
                    ref={inputRef}
                    type={type}
                    width={inputWidth}
                    className={className}
                    placeholder={placeholder}
                    defaultValue={defaultValue}
                    value={value}
                    min={min}
                    max={max}
                    rows={rows}
                    border={border}
                    borderRadius={borderRadius}
                    disabled={disabled}
                    readOnly={readOnly}
                    onChange={handleSearch}
                    invalid={invalid}
                    onKeyPress={onKeyPress}
                    checked={checked}
                    paddingBottom={paddingBottom}
                    paddingTop={paddingTop}
                />
            </InputContainer>
            {errorMessage && (
                <div className="invalid-feedback">
                    {errorMessage}
                </div>
            )}
        </div>
    );
}
